/* eslint-disable */
import BaseService from "../../BaseService";

const { http } = BaseService();

// API

export function GetAll() {
  return http({
    url: "UnitRole/get",
    method: "get",
  });
}

export function GetByCurrentUser() {
  return http({
    url: "UnitRole/GetByCurrentUser",
    method: "get",
  });
}

export function GetById(data) {
  return http({
    url: "UnitRole/get-by-id/" + data,
    method: "get",
  });
}

export function RolesCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "UnitRole/Create",
    method: "post",
    data,
  });
}

export function RolesUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "UnitRole/Update",
    method: "post",
    data,
  });
}
export function UpdateAction(postdata) {
  const data = { ...postdata };
  return http({
    url: "UnitRole/update-action",
    method: "post",
    data,
  });
}

export function RolesDelete(postdata) {
  // const data = { ...postdata };
  return http({
    url: "UnitRole/Delete/" + postdata,
    method: "post",
  });
}

/////////////////////////////////////////////
